<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2p" id="part1"><a id="page_17"></a>P<span class="small">ART</span> I<br/><br/>Building the Skills <a id="page_18"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?9e7d8768